function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useInput } from '../../../../machines/inputMachine/useInput';
import React, { useEffect, useMemo } from 'react';
import { Stack } from '../../../Stack';
import { Label } from '../../../Label';
import { SearchDropdown } from '../../../Search/SearchDropdown';
import { FieldErrorMessage } from '../../../Validation/FieldErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateYears = (min, max) => {
  const years = [];
  for (let i = max; i >= min; i--) {
    years.push(i);
  }
  return years;
};
export const YearRangeSelectControl = props => {
  const {
    value,
    send,
    errorMessage,
    touched,
    name
  } = useInput(props.inputService);
  useEffect(() => {
    if (!(value !== null && value !== void 0 && value.From) && !(value !== null && value !== void 0 && value.To) && props.defaultStartYear) {
      const defaultValue = {
        From: props.defaultStartYear,
        To: undefined
      };
      commitDataChange(defaultValue);
    }
  }, []);
  const yearsFrom = useMemo(() => {
    var _value$To;
    return generateYears(props.min, (_value$To = value === null || value === void 0 ? void 0 : value.To) !== null && _value$To !== void 0 ? _value$To : props.max).reverse();
  }, [value === null || value === void 0 ? void 0 : value.To]);
  const yearsTo = useMemo(() => {
    var _value$From;
    return generateYears((_value$From = value === null || value === void 0 ? void 0 : value.From) !== null && _value$From !== void 0 ? _value$From : props.min, props.max);
  }, [value === null || value === void 0 ? void 0 : value.From]);
  const commitDataChange = value => {
    send([{
      type: 'FOCUS'
    }, {
      type: 'CHANGE',
      value: value
    }, {
      type: 'BLUR'
    }, {
      type: 'COMMIT'
    }]);
  };
  return /*#__PURE__*/_jsxs(Stack, {
    styles: {
      root: {
        width: '100%'
      }
    },
    children: [!props.isLabelHidden && /*#__PURE__*/_jsx(Label, {
      disabled: props.disabled,
      children: props.label || name
    }), /*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      tokens: {
        childrenGap: 10
      },
      children: [/*#__PURE__*/_jsxs(Stack, {
        styles: {
          root: {
            width: '100%',
            position: 'relative'
          }
        },
        "data-id": "from-year",
        children: [!props.isLabelFromHidden && /*#__PURE__*/_jsx(Label, {
          disabled: props.disabled,
          children: props.labelFrom
        }), /*#__PURE__*/_jsx(SearchDropdown, {
          optionList: yearsFrom,
          value: value === null || value === void 0 ? void 0 : value.From,
          renderData: item => item ? item.toString() : '',
          onChange: newValue => {
            commitDataChange(_objectSpread(_objectSpread({}, value), {}, {
              From: newValue
            }));
          },
          maxItemsOverlay: 5,
          placeholder: props.placeholderFrom,
          disabled: props.disabled
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        styles: {
          root: {
            width: '100%',
            position: 'relative'
          }
        },
        "data-id": "to-year",
        children: [!props.isLabelToHidden && /*#__PURE__*/_jsx(Label, {
          disabled: props.disabled,
          children: props.labelTo
        }), /*#__PURE__*/_jsx(SearchDropdown, {
          optionList: yearsTo,
          value: value === null || value === void 0 ? void 0 : value.To,
          renderData: item => item ? item.toString() : '',
          maxItemsOverlay: 5,
          onChange: newValue => {
            commitDataChange(_objectSpread(_objectSpread({}, value), {}, {
              To: newValue
            }));
          },
          placeholder: props.placeholderTo,
          disabled: props.disabled
        })]
      })]
    }), errorMessage && touched && errorMessage.map(error => /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }))]
  });
};
YearRangeSelectControl.defaultProps = {
  min: 1888,
  max: new Date().getFullYear() + 10,
  labelFrom: 'From',
  labelTo: 'To',
  placeholderFrom: 'From',
  placeholderTo: 'To',
  disabled: false
};